export const CONCEPT_CATEGORIES = [
  "", "Skincare", "Haircare", "Color Cosmetics", "Fragrance", "Bodycare",
  "Wellness", "Sleep / Recovery", "Functional Beverages", "Beauty Tools", "Suncare", "Oral Care",
];

export const CONCEPT_GEOGRAPHIES = [
  "", "China", "Thailand", "Korea", "Japan", "North America", "Western Europe", "Global",
];

export const CONCEPT_ARCHETYPES = [
  "", "tier-2 ritual-keeper", "k-beauty authority", "scent-stacker",
  "humid-climate creator", "gen-z aesthetic", "wellness-modernist",
  "sleep-hygiene educator", "ingredient-decoder",
];